import React from 'react';
import styles from './UnderlineButton.module.css';

interface UnderlineButtonProps {
    onClick: () => void; // Function to execute on click
    children: React.ReactNode; // Button content (e.g., "Log in", "Submit")
    className?: string; // Optional: Custom styles
    disabled?: boolean; // Optional: Disable the button
    textSize?: 'small' | 'large';
}

const UnderlineButton: React.FC<UnderlineButtonProps> = ({
    onClick,
    children,
    className = '',
    disabled = false,
    textSize = 'large',
}) => {
    return (
        <button
            type="button"
            className={`${styles.underlineButton} ${disabled ? styles.disabled : ''} ${className} ${textSize === 'small' ? styles.smallText : styles.largeText}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default UnderlineButton;
